import React from 'react';

/**
 * Estado vacío elegante reutilizable para secciones (eventos, vídeos, directos, etc).
 */
export function EmptyBlock({ icon: Icon, title, description, testId }) {
  return (
    <div
      className="flex flex-col items-center justify-center py-10 px-6 rounded-2xl border border-dashed border-[var(--ns-border)] bg-white text-center"
      data-testid={testId}
    >
      {Icon ? (
        <div className="h-12 w-12 rounded-2xl bg-[var(--ns-gold)]/15 text-[var(--ns-gold-700)] inline-flex items-center justify-center mb-4">
          <Icon className="h-6 w-6" />
        </div>
      ) : null}
      <h4 className="font-display text-base text-[var(--ns-text)]">{title}</h4>
      {description ? (
        <p className="mt-1 text-sm text-[var(--ns-text-muted)] max-w-sm leading-relaxed">
          {description}
        </p>
      ) : null}
    </div>
  );
}
